import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/verification/useVerificationQueryKeys.ts
var t = e("verification", {
	identity: () => ["identity"],
	business: () => ["business"],
	identityBadge: (e) => ["identity-badge", e]
});
//#endregion
export { t as verificationQueryKeys };
